import * as React from "react";
import { useComposedRefs, useLayoutEffect } from "radix-ui/internal";

/**
 * HACK: Radix themes does not expose the dialog overlay, but we want consumer
 * to be able to style it with a classname. This will add a classname to the
 * overlay when the dialog content is mounted.
 */
export function useDialogOverlayHack(
  forwardedRef: React.Ref<HTMLDivElement | null>,
  { className, selector }: { className: string; selector: string },
): { ref: React.Ref<HTMLDivElement | null> } {
  const [node, setNode] = React.useState<HTMLDivElement | null>(null);
  const ref = useComposedRefs(forwardedRef, setNode as any);
  useLayoutEffect(() => {
    if (!node) {
      return;
    }
    const document = node.ownerDocument;
    const overlay = document.querySelector<HTMLDivElement>(selector);
    overlay?.classList.add(className);
  }, [node, className, selector]);

  return { ref };
}
